// extracted by mini-css-extract-plugin
module.exports = {"cnt":"LoginModule_cnt__2R9Pw","login":"LoginModule_login__1ioq2","logo":"LoginModule_logo__3OJDW","form":"LoginModule_form__1dcXv","sidebar":"LoginModule_sidebar__3GUbR"};